import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { jobStatuses } from '../../../constants/jobs';

export default class StatusFilter extends Component {
  selectStatus = event => {
    event.persist();
    this.props.selectStatus(event.target.name);
  };

  _setButtonClass = buttonStatus => {
    let buttonClass = 'filter-button';

    if (this.props.statuses.includes(buttonStatus)) {
      buttonClass += ' active';
    }

    return buttonClass;
  };

  _renderButton = (status) => (
    <button
      className={this._setButtonClass(status.server)}
      name={status.server}
      onClick={this.selectStatus}
    >
      {status.ui}
    </button>
  );

  render () {
    return this.props.isCurrentPeriod ? (
      <div className='status-filter-buttons'>
        {this._renderButton(jobStatuses.saved)}
        {this._renderButton(jobStatuses.posted)}
        {this._renderButton(jobStatuses.filled)}
        {this._renderButton(jobStatuses.cancelled)}
      </div>
    ) : (
      <div className='status-filter-buttons'>
        <button className={`filter-button ${this.props.get_not_completed ? 'active' : ''}`}
          onClick={this.props.toggleNonCompleted}>Not Approved</button>
        {this._renderButton(jobStatuses.completed)}
        {this._renderButton(jobStatuses.cancelled)}
      </div>
    );
  }
}

StatusFilter.propTypes = {
  selectStatus: PropTypes.func,
  statuses: PropTypes.array,
  isCurrentPeriod: PropTypes.bool,
  get_not_completed: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]),
  toggleNonCompleted: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/app/jobsList/StatusFilter.js